import script from "./ComponentFormItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComponentFormItem.vue?vue&type=script&setup=true&lang=ts"

import "./ComponentFormItem.vue?vue&type=style&index=0&id=62f46424&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f46424"]])

export default __exports__